/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon16Solid = forwardRef('CheckA2Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.187 5.313a1 1 0 0 0-1.415-1.415L3.901 9.77a.587.587 0 0 1-.83 0L1.742 8.443A1 1 0 0 0 .33 9.857l1.327 1.327a2.587 2.587 0 0 0 3.66 0l5.87-5.871Z" }),
        React.createElement("path", { d: "M15.678 5.313a1 1 0 1 0-1.414-1.415l-6.395 6.396a1 1 0 1 0 1.414 1.414l6.395-6.395Z" })));
});
